export default __webpack_public_path__ + "static/media/ferramenta-reels-img3.bccbd707.jpeg";